export class LocalSetting {

    private static logging: boolean;

    public static getLoggin(): boolean {
        if (LocalSetting.logging !== undefined) {
            return LocalSetting.logging;
        }
        const logging = localStorage.getItem('justa.logging');
        // localStorge based on origin, ie  web site, so the setting on one site can't be seen for another site
        // every site has at least 5mb size
        if (logging) {
            LocalSetting.logging = logging.toLowerCase() === 'true';
        } else {
            LocalSetting.logging = false;
        }
        return LocalSetting.logging;
    }
}
